module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/201-martinique-9a324f4e9d409316d070f368cacb5fbd.svg";